import CampaignIcon from "@mui/icons-material/Campaign";
import permissions from "app/permissions";
import { CAMPAIGNS, ScholarshipServicePath } from "utils/constants";
import ListScholarshipCampaigns from "./List";
import CreateScholarshipCampaigns from "./Create";
import EditScholarshipCampaigns from "./Edit";
import ShowScholarshipCampaigns from "./Show";

export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  name: ScholarshipServicePath + CAMPAIGNS,
  title: "Кампании стипендии",
  list: <ListScholarshipCampaigns />,
  create: <CreateScholarshipCampaigns />,
  edit: <EditScholarshipCampaigns />,
  show: <ShowScholarshipCampaigns />,
  permission: permissions.canPreviewScholarshipCampaigns,
};
